import User from "../users/User";
import Phase from "./Phase";
import ContractTime from "./ContractTime";
import Currency from "./Currency";
import Type from "./Type";

export default {
  Name: "",
  CustomerCode: "",
  ContactDocument: "",
  CompanyName: "",
  ContactName: "",
  Amount: 0,
  Probability: 0,
  CurrencyID: null,
  Currency: Currency,
  ResponsibleID: null,
  Responsible: User,
  InitialDate: "",
  FinalDate: "",
  DeliveryDate: "",
  ServicesAmount: 0,
  DealsTypeID: null,
  Type: Type,
  Comment: "",
  EstatusID: null,
  Estatus: null,
  Reason: "",
  ContractTimeID: null,
  ContractTime: ContractTime,
  PhaseID: null,
  Phase: Phase,
  Quantity: 0,
  UnitPrice: 0,
  IsLosed: false,
  IsWinned: false,
  CompanyID: "",
  GetSubTotals: 0,
  DealsLogs: null,
  Comments: null,
  CreatedBy: null,
  CreatedAt: "",
  CreatedByUser: User,
  UpdatedBy: null,
  UpdatedByUser: User,
  LastUpdatedAt: "",
  Id: null,
  IsEnabled: false,
  IsNull: false,
  ProductID: null,
  CustomerService: null,
  CustomerServiceId: null,
  Product: null,
  Seller: null,
  SellerFullName: null,
  SellerId: null,
  SellerPositionId: null,
  SellerStatus: null,
  SupportSeller: null,
  SupportSellerId: null
};
